import React, { Fragment } from 'react';
import { useQuery } from "react-query";
import { Link } from 'react-router-dom';

import { ButtonsRow, Column, ColumnContainer, Divider, MainButton, SectionTitle, TileSlider, TitleContainer } from "@beacharound/beacharound-ui";
import { getProductImage } from "@beacharound/beacharound-ui-helpers";

import { getProducts } from '../../api/products';
import { getBundleTitle } from '../../helpers/products';
import isFuture from 'date-fns/isFuture';

export default function BeachesProductsSeasonalSlider({ match }) {

    const { beachSlug } = match.params;

    const options = {
        limit: 200,
        params: {
            bundleType: 'seasonal'
        }
    };

    const { data: bundles } = useQuery(["beaches", beachSlug, "products", "seasonal", options], () =>
        getProducts({ activitySlug: beachSlug, ...options }),
        { enabled: !!beachSlug }
    );

    let products = !!bundles?.length ? bundles?.filter(({ toDate }) => !toDate || isFuture(new Date(toDate))) : [];

    if (!products || products.length <= 0 || !Array.isArray(products)) {
        return <Fragment></Fragment>;
    }

    return (
        <ColumnContainer noMargin>
            <Column>
                <TitleContainer>
                    <SectionTitle text="Listino dei prodotti stagionali" />
                </TitleContainer>
                <ColumnContainer noMargin>
                    <Column>
                        <TileSlider slides={products.sort((a, b) => a.price - b.price).map(product => {
                            let string = "A partire da";

                            if (product.bundleType === 'seasonal') {
                                string = "Stagionale a"
                            }

                            const { title, subtitle } = getBundleTitle(product, { main: true });
                            const price = product.price?.toFixed(2)
                            const priceComparison = product.priceComparison && product.priceComparison?.toFixed(2);
                            string = `${string} ${priceComparison ? `<strike>${priceComparison} €</strike> ` : ""}${price}€`
                            return {
                                images: product.relatedProducts?.map(prod => getProductImage(prod.reference?.type)),
                                title,
                                text: subtitle,
                                pretitle: product.price > 0 ? string : "",
                                highlight: priceComparison ? "In sconto!" : ""
                            }
                        })} />
                    </Column>
                </ColumnContainer>
                <ButtonsRow fill marginBottom>
                    <MainButton
                        border
                        text="Vedi tutti i prezzi stagionali"
                        component={Link}
                        to={`/spiagge/${beachSlug}/prezzi-abbontamenti-stagionali-ombrellone-lettino-sdraio`}
                    />
                </ButtonsRow>
                <Divider />
            </Column>
        </ColumnContainer>
    );
}